import Image from 'next/image';
import { ItineraryMapContainer } from './ItineraryMap.styles';
import { getBrandUISettings } from 'lib/utilities/Brands';
import { useConfig } from 'hooks';
import { useState } from 'react';

interface ItineraryMapProps {
  readonly portSequence: string,
};

function ItineraryMap ({ portSequence }: ItineraryMapProps) {
  const { mapsBaseUrl, brand } = useConfig();
  const { itineraryMapPath } = getBrandUISettings(brand.code); 
  const itineraryMapGif = `${mapsBaseUrl}${itineraryMapPath}${portSequence}_1200x430.gif`;
  const [showMap, setShowMap] = useState(false);

  return (
    <ItineraryMapContainer showMap={showMap} >
      <Image src={itineraryMapGif} alt='' layout='fill' unoptimized={true} priority={true} onLoad={() => setShowMap(true)}/>        
    </ItineraryMapContainer>
  );
}

export default ItineraryMap;

